class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
  
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
  
    const facetForm = this.querySelector('form');
    if (facetForm) {
      /* input: checkbox / metin / aralık — canlı güncelleme. select: sadece change (açılışta input tetiklenmesin) */
      facetForm.addEventListener('input', (event) => {
        if (event.target.tagName === 'SELECT') return;
        this.debouncedOnSubmit(event);
      });
      facetForm.addEventListener('change', (event) => {
        if (event.target.tagName === 'SELECT') {
          this.debouncedOnSubmit(event);
        }
      });
    }
    const sortFormToolbar = this.querySelector('#FacetSortForm');
    if (sortFormToolbar && sortFormToolbar !== facetForm) {
      sortFormToolbar.addEventListener('change', this.debouncedOnSubmit.bind(this));
    }
  
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const isMobileViewport =
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(max-width: 991px)').matches;

    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const dest = document.querySelector(selector);
      const src = html.querySelector(selector);
      if (dest && src) dest.innerHTML = src.innerHTML;
    });

    /*
     * .sorting: Masaüstünde önceki mantık (aynı value + aynı seçenek sayısı → atla).
     * Responsive (≤991px): #FacetSortForm (toolbar) içindeki sıralama için innerHTML hiç güncellenmez —
     * Shopify cevabında .sorting sırası / parser farkı yüzünden yanlış eşleşme ve açık <select>'in silinmesi engellenir.
     */
    const srcSortings = html.querySelectorAll('.sorting');
    if (srcSortings.length) {
      document.querySelectorAll('.sorting').forEach((destSort, i) => {
        const srcSort = srcSortings[i];
        if (!srcSort) return;

        if (isMobileViewport && destSort.closest('#FacetSortForm')) {
          return;
        }

        const destSel = destSort.querySelector('select[name="sort_by"]');
        const srcSel = srcSort.querySelector('select[name="sort_by"]');
        if (
          destSel &&
          srcSel &&
          destSel.value === srcSel.value &&
          destSel.options.length === srcSel.options.length
        ) {
          return;
        }
        destSort.innerHTML = srcSort.innerHTML;
      });
    }

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm) {
      const drawer = mobileForm.closest('menu-drawer');
      if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/** Figma mobil filtre: açıkken özet satırına tıklama kapanmasın; yalnızca ok (summary içi svg) toggle eder. */
document.addEventListener(
  'click',
  (e) => {
    const summary = e.target.closest('#FacetFiltersFormMobile.mobile-facets--figma summary.facets__summary');
    if (!summary) return;
    const details = summary.closest('details');
    if (!details || !details.classList.contains('mobile-facets__details') || !details.classList.contains('js-filter')) return;
    if (!details.hasAttribute('open')) return;
    if (!e.target.closest('summary svg')) {
      e.preventDefault();
    }
  },
  true
);

class PriceRange extends HTMLElement {
  connectedCallback() {
    if (this.dataset.priceRangeBound === 'true') return;
    this.dataset.priceRangeBound = 'true';

    if (this.classList.contains('facets__price--figma-dual-slider')) {
      this.initFigmaDualSlider();
      return;
    }

    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (!minInput || !maxInput) return;
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  initFigmaDualSlider() {
    const minInput = this.querySelector('[data-price-input="min"]');
    const maxInput = this.querySelector('[data-price-input="max"]');
    const track = this.querySelector('.fig-price-slider__track');
    const fill = this.querySelector('[data-fig-range]');
    const thumbMin = this.querySelector('[data-thumb="min"]');
    const thumbMax = this.querySelector('[data-thumb="max"]');
    const bubbleMin = this.querySelector('[data-bubble="min"]');
    const bubbleMax = this.querySelector('[data-bubble="max"]');
    const tipMin = this.querySelector('.fig-price-slider__tooltip-text--min');
    const tipMax = this.querySelector('.fig-price-slider__tooltip-text--max');
    if (!minInput || !maxInput || !track || !fill || !thumbMin || !thumbMax || !bubbleMin || !bubbleMax || !tipMin || !tipMax) return;

    const parseMaxFromInput = () => {
      const raw = String(maxInput.getAttribute('max') || '0').replace(',', '.');
      const n = parseFloat(raw);
      return Number.isFinite(n) ? n : 0;
    };

    let rangeMax = parseFloat(String(this.dataset.rangeMax || '').replace(',', '.'));
    if (!Number.isFinite(rangeMax) || rangeMax <= 0) rangeMax = parseMaxFromInput();
    if (!Number.isFinite(rangeMax) || rangeMax <= 0) return;

    const usesCommaDecimals = this.dataset.usesCommaDecimals === 'true';
    const currencyCode = this.dataset.currencyCode || 'USD';
    const currencySymbol = this.dataset.currencySymbol || '$';

    const parseInputNumber = (inp) => {
      const v = String(inp.value || '').trim();
      if (!v) return null;
      return parseFloat(v.replace(',', '.'));
    };

    const formatForInput = (n) => {
      if (n === null || n === undefined || !Number.isFinite(n)) return '';
      let s = String(Math.round(n * 100) / 100);
      if (usesCommaDecimals) s = s.replace('.', ',');
      else s = s.replace(/,/g, '');
      return s;
    };

    let minVal = parseInputNumber(minInput);
    let maxVal = parseInputNumber(maxInput);
    if (minVal === null || !Number.isFinite(minVal) || minVal < 0) minVal = 0;
    if (maxVal === null || !Number.isFinite(maxVal) || maxVal > rangeMax) maxVal = rangeMax;
    if (minVal > maxVal) {
      const t = minVal;
      minVal = maxVal;
      maxVal = t;
    }

    const minGap = Math.max(1, rangeMax * 0.01);

    let moneyFormatter;
    try {
      moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      });
    } catch (e) {
      moneyFormatter = null;
    }

    const formatMoney = (amount) => {
      if (moneyFormatter) {
        try {
          return moneyFormatter.format(amount);
        } catch (e2) {
          /* fall through */
        }
      }
      return `${currencySymbol}${Math.round(amount)}`;
    };

    const setVisuals = () => {
      const minPct = rangeMax > 0 ? (minVal / rangeMax) * 100 : 0;
      const maxPct = rangeMax > 0 ? (maxVal / rangeMax) * 100 : 100;
      thumbMin.style.left = `${minPct}%`;
      thumbMax.style.left = `${maxPct}%`;
      bubbleMin.style.left = `${minPct}%`;
      bubbleMax.style.left = `${maxPct}%`;
      fill.style.left = `${minPct}%`;
      fill.style.width = `${Math.max(0, maxPct - minPct)}%`;
      tipMin.textContent = formatMoney(minVal);
      tipMax.textContent = formatMoney(maxVal);
    };

    const writeInputsAndSubmit = () => {
      const fullRange = minVal <= 0 && maxVal >= rangeMax - 0.0001;
      if (fullRange) {
        minInput.value = '';
        maxInput.value = '';
      } else {
        minInput.value = formatForInput(minVal);
        maxInput.value = formatForInput(maxVal);
      }
      minInput.dispatchEvent(new Event('input', { bubbles: true }));
      maxInput.dispatchEvent(new Event('input', { bubbles: true }));
    };

    let dragTarget = null;
    let captureEl = null;

    const valueFromClientX = (clientX) => {
      const rect = track.getBoundingClientRect();
      let pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      return (pct / 100) * rangeMax;
    };

    const applyDragValue = (rawVal) => {
      let v = rawVal;
      if (dragTarget === 'min') {
        v = Math.max(0, Math.min(v, maxVal - minGap));
        minVal = v;
      } else if (dragTarget === 'max') {
        v = Math.min(rangeMax, Math.max(v, minVal + minGap));
        maxVal = v;
      }
      setVisuals();
    };

    const onPointerMove = (e) => {
      if (!dragTarget) return;
      if (e.cancelable) e.preventDefault();
      applyDragValue(valueFromClientX(e.clientX));
    };

    const onPointerUp = (e) => {
      if (!dragTarget) return;
      if (e.cancelable) e.preventDefault();
      dragTarget = null;
      document.removeEventListener('pointermove', onPointerMove);
      document.removeEventListener('pointerup', onPointerUp);
      document.removeEventListener('pointercancel', onPointerUp);
      if (captureEl && e.pointerId != null) {
        try {
          captureEl.releasePointerCapture(e.pointerId);
        } catch (_) {
          /* ignore */
        }
      }
      captureEl = null;
      writeInputsAndSubmit();
    };

    const onThumbDown = (which) => (e) => {
      e.preventDefault();
      dragTarget = which;
      captureEl = e.currentTarget;
      try {
        captureEl.setPointerCapture(e.pointerId);
      } catch (_) {
        /* ignore */
      }
      document.addEventListener('pointermove', onPointerMove, { passive: false });
      document.addEventListener('pointerup', onPointerUp, { passive: false });
      document.addEventListener('pointercancel', onPointerUp, { passive: false });
      applyDragValue(valueFromClientX(e.clientX));
    };

    thumbMin.addEventListener('pointerdown', onThumbDown('min'));
    thumbMax.addEventListener('pointerdown', onThumbDown('max'));

    setVisuals();
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
